import React from "react";
type Props = {
  disabled?: boolean;
  primary?: boolean;
  btnType?: "button" | "submit" | "reset" | undefined;
  label?: string;
  btnURL?: string;
  customClass: string;
  text?: boolean;
  image?: string;
  alt?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
}

export default function Button({
  disabled = false,
  primary = true,
  btnType = "button",
  customClass,
  label,
  btnURL,
  text,
  image,
  alt,
  width,
  height,
  onClick,
  ...props
}: Props) {
  const type = primary ? "btn-success" : "btn-success success-reverse";
  return (
    <>
      <button
        className={`btn mybtn ${text ? type : ""} ${customClass}`}
        style={text ? {} : { background: 'none' }}
        data-testid="btncomponent"
        onClick={onClick}
        type={btnType}
        disabled={disabled}
        {...props}>
        {text ? label : <img src={image} alt={alt} width={width} height={height} />}
      </button>
    </>
  )
}
